import { render, staticRenderFns } from "./TeacherWorkRecommendHistory.vue?vue&type=template&id=91edc218&scoped=true"
import script from "./TeacherWorkRecommendHistory.vue?vue&type=script&lang=js"
export * from "./TeacherWorkRecommendHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91edc218",
  null
  
)

export default component.exports